import { z } from "zod";

export const passwordSchema = z
    .object({
        password: z.string().min(5).max(100),
        passwordConfirm: z.string().min(5).max(100),
    })
    .refine(({ password, passwordConfirm }) => password === passwordConfirm, {
        path: ["passwordConfirm"],
        message: "Şifreler eşleşmiyor.",
    });

export type PasswordSchema = z.infer<typeof passwordSchema>;
